// src/resources/sections/dataConfig.ts
import type { ResourceConfig } from "../resourceTypes";
export const DATA_CONFIG: ResourceConfig[] = [
  {
    name: "todos",
    label: "Todos",
    schema: "data",
    fields: [
      {
        source: "title",
        label: "title",
        kind: "text",
        list: true,
        form: true,
      },
      {
        source: "created_at",
        label: "created_at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
      {
        source: "updated_at",
        label: "updated_at",
        kind: "date",
        list: true,
        form: false,
        editDisabled: true,
      },
    ],
    searchFields: ["title"],
  },
];
